"use client";

import Link from "next/link";
import { ArrowRight, CheckCircle2, MessageCircle, Phone } from "lucide-react";

const CTASection = () => {
  return (
    <section className="bg-[#FFFFFF] px-5 pb-20 sm:px-8 md:pb-28 lg:px-10">
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2rem] bg-[#0369A1] px-6 py-14 text-white sm:px-10 md:px-16 md:py-20">
        <div className="absolute -right-20 -top-24 h-80 w-80 rounded-full border-[50px] border-white/8" />
        <div className="absolute -bottom-32 left-1/3 h-64 w-64 rounded-full bg-[#0C4A6E]/10 blur-2xl" />

        <div className="relative grid gap-10 lg:grid-cols-[1fr_auto] lg:items-center">
          <div>
            <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-white/70 uppercase">
              A safer home starts here
            </p>
            <h2 className="max-w-3xl text-4xl leading-[1.08] font-extrabold tracking-[-0.04em] sm:text-5xl md:text-6xl">
              Tell us what you need. We&apos;ll make it safe.
            </h2>
            <div className="mt-6 flex flex-wrap gap-x-6 gap-y-3 text-sm font-semibold text-white/80">
              {["Free site estimate", "Transparent pricing", "Fast installation"].map(
                (item) => (
                  <span key={item} className="flex items-center gap-2">
                    <CheckCircle2 className="size-4" />
                    {item}
                  </span>
                ),
              )}
            </div>
          </div>

          <div className="flex min-w-[240px] flex-col gap-3">
            <a
              href="tel:+917995792953"
              className="inline-flex min-h-13 items-center justify-center gap-2 rounded-full bg-[#0C4A6E] px-6 py-3.5 font-extrabold text-white shadow-lg transition hover:bg-[#082F49]"
            >
              <Phone className="size-4" />
              Call +91 79957 92953
            </a>
            <a
              href="https://wa.me/917995792953"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-13 items-center justify-center gap-2 rounded-full border border-white/45 bg-white/12 px-6 py-3.5 font-bold text-white transition hover:bg-white hover:text-[#075985]"
            >
              <MessageCircle className="size-4" />
              WhatsApp us
            </a>
            <Link
              href="/contactUs"
              className="inline-flex items-center justify-center gap-2 py-2 text-sm font-bold text-white/80 transition hover:text-white"
            >
              Request a callback
              <ArrowRight className="size-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
